import {defineField, defineType} from 'sanity'
import {crossDatabaseReference} from '../fragments/dotcom.document'

export default defineType({
  name: 'site',
  title: 'Site settings',
  type: 'document',
  groups: [{name: 'branding', default: true}, {name: 'navigation'}, {name: 'info'}],
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      validation: (Rule) => Rule.required(),
      group: 'branding',
    }),
    defineField({
      name: 'header',
      type: 'reference',
      to: [{type: 'navigation'}],
      group: 'navigation',
    }),
    defineField({
      name: 'footer',
      type: 'reference',
      to: [{type: 'navigation'}],
      group: 'navigation',
    }),
    defineField({
      name: 'subscribeToNewsletterContent',
      title: 'Subscribe to newsletter content',
      description: 'link to .com content for subscribe to newsletter.',
      ...crossDatabaseReference('microContentSubscribeToNewsletter'),
      group: 'branding',
    }),
    defineField({
      name: 'formDisclaimer',
      title: 'Form disclaimer',
      description: 'link to .com content for form disclaimer.',
      ...crossDatabaseReference('formDisclaimer'),
      group: 'branding',
    }),
  ],
  preview: {
    prepare: () => ({
      title: 'Site settings',
    }),
  },
})
